/**
 * icons.jsx — inline SVG icon components.
 * All icons render at 1em by default so size is controlled via
 * parent font-size or className (e.g. w-5 h-5).
 */

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: '1.8',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export function VoiceIcon({ 'aria-hidden': ariaHidden = 'true', ...props }) {
  return (
    <svg {...base} aria-hidden={ariaHidden} {...props}>
      <path d="M12 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z" />
      <path d="M19 10v1a7 7 0 0 1-14 0v-1" />
      <line x1="12" y1="18" x2="12" y2="22" />
      <line x1="8" y1="22" x2="16" y2="22" />
    </svg>
  );
}

export function SalesIcon({ 'aria-hidden': ariaHidden = 'true', ...props }) {
  return (
    <svg {...base} aria-hidden={ariaHidden} {...props}>
      <path d="M3 3v18h18" />
      <path d="M7 15l4-4 3 3 5-6" />
    </svg>
  );
}

export function FinanceIcon({ 'aria-hidden': ariaHidden = 'true', ...props }) {
  return (
    <svg {...base} aria-hidden={ariaHidden} {...props}>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 10h18" />
      <path d="M8 15h4" />
    </svg>
  );
}

export function SupportIcon({ 'aria-hidden': ariaHidden = 'true', ...props }) {
  return (
    <svg {...base} aria-hidden={ariaHidden} {...props}>
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );
}

export function EmailIcon({ 'aria-hidden': ariaHidden = 'true', ...props }) {
  return (
    <svg {...base} aria-hidden={ariaHidden} {...props}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </svg>
  );
}

export function SocialIcon({ 'aria-hidden': ariaHidden = 'true', ...props }) {
  return (
    <svg {...base} aria-hidden={ariaHidden} {...props}>
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="5" r="3" />
      <circle cx="18" cy="19" r="3" />
      <line x1="8.6" y1="10.6" x2="15.4" y2="6.4" />
      <line x1="8.6" y1="13.4" x2="15.4" y2="17.6" />
    </svg>
  );
}

export function MenuIcon({ 'aria-hidden': ariaHidden = 'true', ...props }) {
  return (
    <svg {...base} strokeWidth="2" aria-hidden={ariaHidden} {...props}>
      <line x1="3" y1="7" x2="21" y2="7" />
      <line x1="3" y1="17" x2="21" y2="17" />
    </svg>
  );
}

/** Map keyword -> icon component, used by content modules */
export const iconMap = {
  voice: VoiceIcon,
  sales: SalesIcon,
  finance: FinanceIcon,
  support: SupportIcon,
  email: EmailIcon,
  social: SocialIcon,
};
